module.exports = __webpack_public_path__ + "img/shopNum4.a29dffbf.jpg";